export default {"src":"/_next/static/media/youtube.0a8af2d3.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};